import { render, staticRenderFns } from "./ISAInsights.vue?vue&type=template&id=229d103e&scoped=true&"
import script from "./ISAInsights.vue?vue&type=script&lang=js&"
export * from "./ISAInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d103e",
  null
  
)

export default component.exports